import { ADD_PROFILE_DATA } from '../../../actions'

export const addProfileDataReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_PROFILE_DATA:
      return { ...state, [action.mdid]: action.payload }

    default:
      return state
  }
}
